<template>
  <div class="container">
    <div class="search_box">
      <el-form ref="form" class="search_form" :model="tableParams" label-position="left">
        <el-form-item label="搜索内容" label-width="70px">
          <el-input v-model="tableParams.searchParam" placeholder="请输入搜索内容" clearable></el-input>
        </el-form-item>

        <el-form-item label="工单类型" label-width="70px">
          <el-select v-model="tableParams.orderType" placeholder="请选择工单类型" clearable>
            <el-option v-for="item in orderStateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请日期" label-width="70px">
          <el-date-picker v-model="timeList" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" @change="timeChange">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" class="search_area_btn" @click="onSubmit">搜索</el-button>
          <el-button icon="el-icon-upload2" class="search_area_btn" @click="downloadExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table_box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="1">
          <span slot="label">待审核 ({{ OrderNumData.daiShenHe }})</span>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">已审核 ({{ OrderNumData.daiZhiPai + OrderNumData.woFanHuan }})</span>
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label">待确认 ({{ OrderNumData.daiQueRen }})</span>
        </el-tab-pane>
        <el-tab-pane name="4">
          <span slot="label">已确认 ({{ OrderNumData.yiWanChen }})</span>
        </el-tab-pane>
      </el-tabs>
      <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
        v-loading="tableLoading">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="id" label="工单编号"> </el-table-column>
        <el-table-column property="orgName" label="企业名称"> </el-table-column>
        <el-table-column property="carNumber" label="车牌号码" width="100">
        </el-table-column>
        <el-table-column property="contactsName" label="联系人">
        </el-table-column>
        <el-table-column property="contactsPhone" label="联系方式" width="120">
        </el-table-column>
        <el-table-column property="contactsEmail" label="联系邮箱" width="120">
        </el-table-column>
        <el-table-column property="addr" label="区域地址" width="120">
        </el-table-column>
        <el-table-column property="addrDetail" label="详细地址" width="200">
        </el-table-column>
        <el-table-column property="orderTypeDesc" label="工单类型" width="120">
        </el-table-column>
        <el-table-column property="orderStatusDesc" label="工单状态" width="180">
        </el-table-column>
        <el-table-column property="createUser" label="创建人">
        </el-table-column>
        <el-table-column property="auditTime" label="处理时间" width="180">
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
            <el-button type="text" @click="goAudit(scope.row)"
              v-if="tableParams.orderStatus == '10' && scope.row.auditUser === userInfo.userId">审核</el-button>
            <el-button type="text" @click="goAssign(scope.row)"
              v-else-if="tableParams.orderStatus == '20' && scope.row.auditUser === userInfo.userId">指派</el-button>
            <el-button type="text" @click="goConfirmOrder(scope.row)" v-else-if="tableParams.orderStatus == '40' &&
              scope.row.auditUser === userInfo.userId
              ">确认</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="paging_box">
        <!--  :current-page="currentPage4" -->
        <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 审核工单 -->
    <v-audit :show.sync="auditShow" :data="auditData"></v-audit>
    <!-- 指派工单 -->
    <v-assign :show.sync="assignShow" :data="assignData"></v-assign>
    <!-- 确认工单 -->
    <v-confirmOrder :show.sync="confirmOrderShow" :data="confirmOrderData"></v-confirmOrder>
    <!-- 工单详情 -->
    <v-detail :show.sync="detailShow" :data="detailData"></v-detail>
  </div>
</template>

<script>
import ConfirmOrder from "./component/confirmOrder";
import audit from "./component/audit.vue";
import assign from "./component/assign.vue";
import confirmOrder from "./component/confirmOrder.vue";
import { dateTransition } from "@/utils/util.js";
import detail from "./component/detail.vue";
import config from '@/utils/config';
export default {
  name: "",
  data () {
    return {
      searchForm: {},
      tableData: [],
      tableParams: {
        page: 1,
        limit: 10,
        searchParam: "", // 搜索内容(联系人，联系人电话)
        orderStatus: "10", // 工单状态  10待审核  20已审核  40待确认  50已确认
        startTime: "", // 开始时间
        endTime: "", // 结束时间
        orderType: null, // 工单类型
      },
      timeList: [],
      total: 0,
      tableLoading: false,
      stateList: [],
      activeName: "1",
      auditShow: false,
      auditData: {},
      detailShow: false,
      detailData: {},
      assignShow: false,
      assignData: {},
      confirmOrderShow: false,
      confirmOrderData: {},
      OrderNumData: {},
      orderStateList: [],
      orderTypeList: [],
      listIndex: "0",
      userInfo: "",
    };
  },
  components: {
    ConfirmOrder,
    "v-audit": audit,
    "v-assign": assign,
    "v-confirmOrder": confirmOrder,
    "v-detail": detail,
  },
  props: {},
  created () {
    if (window.location.href.indexOf("yishnehe") != -1) {
      this.activeName = "2";
      this.getYiShengHeList();
    } else if (window.location.href.indexOf("daiqueren") != -1) {
      this.activeName = "3";
      this.getDaiQueRenList();
    } else if (window.location.href.indexOf("yiwancheng") != -1) {
      this.activeName = "4";
      this.getYiQueRenList();
    } else {
      this.activeName = "1";
      this.getDaiShengheList();
    }
    this.getOrderNum();
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.$http.queryDist({ type: "工单类型" }).then((res) => {
      if (res.code === 0) {
        this.orderStateList = res.data;
      } else {
        this.orderStateList = [];
      }
    });
    this.$http.queryDist({ type: "工单状态" }).then((res) => {
      if (res.code === 0) {
        this.orderTypeList = res.data;
      } else {
        this.orderTypeList = [];
      }
    });
  },
  methods: {
    onSubmit () {
      switch (this.listIndex) {
        case "0":
          this.getDaiShengheList();
          break;
        case "1":
          this.getYiShengHeList();
          break;
        case "2":
          this.getDaiQueRenList();
          break;
        case "3":
          this.getYiQueRenList();
          break;
      }
    },
    downloadExport() {
      var data=this.tableParams;
      var url=config.baseUrl+'/workOrder/exportAuditList?Authorization='+sessionStorage.getItem("Token");
      if(data.searchParam){
        url+='&searchParam='+data.searchParam;
      }
      if(data.orderStatus){
        url+='&orderStatus='+data.orderStatus;
      }
      if(data.startTime){
        url+='&startTime='+data.startTime;
      }
      if(data.endTime){
        url+='&endTime='+data.endTime;
      }
      if(data.orderType){
        url+='&orderType='+data.orderType;
      }
      window.open(url, '_blank');
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      switch (this.listIndex) {
        case "0":
          this.getDaiShengheList();
          break;
        case "1":
          this.getYiShengHeList();
          break;
        case "2":
          this.getDaiQueRenList();
          break;
        case "3":
          this.getYiQueRenList();
          break;
      }
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      switch (this.listIndex) {
        case "0":
          this.getDaiShengheList();
          break;
        case "1":
          this.getYiShengHeList();
          break;
        case "2":
          this.getDaiQueRenList();
          break;
        case "3":
          this.getYiQueRenList();
          break;
      }
    },
    addData () {
      this.addShow = true;
    },
    timeChange (e) {
      if (e == null) {
        this.tableParams.startTime = "";
        this.tableParams.endTime = "";
      } else {
        this.tableParams.startTime = dateTransition(e[0]);
        this.tableParams.endTime = dateTransition(e[1]);
      }
    },
    getDaiShengheList () {
      this.tableParams.orderStatus = "10";
      this.$http.queryWorkOrderList(this.tableParams).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.$message.error(res.msg);
        }
      });
    },
    getYiShengHeList () {
      this.tableParams.orderStatus = "20";
      this.$http.queryWorkOrderList(this.tableParams).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.$message.error(res.msg);
        }
      });
    },
    getDaiQueRenList () {
      this.tableParams.orderStatus = "40";
      this.$http.queryWorkOrderList(this.tableParams).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.$message.error(res.msg);
        }
      });
    },
    getYiQueRenList () {
      this.tableParams.orderStatus = "50";
      this.$http.queryWorkOrderList(this.tableParams).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.$message.error(res.msg);
        }
      });
    },
    getOrderNum () {
      this.$http.queryWorkOrderCount().then((res) => {
        if (res.code === 0) {
          this.OrderNumData = res.data;
        } else {
          this.OrderNumData = {};
          this.$message.error(res.msg);
        }
      });
    },
    handleClick (e) {
      this.listIndex = e.index;
      this.tableParams.page = 1;
      this.tableParams.limit = 10;
      this.tableParams.searchParam = "";
      this.tableParams.orderStatus = null;
      this.tableParams.startTime = "";
      this.tableParams.endTime = "";
      switch (e.index) {
        case "0":
          this.getDaiShengheList();
          break;
        case "1":
          this.getYiShengHeList();
          break;
        case "2":
          this.getDaiQueRenList();
          break;
        case "3":
          this.getYiQueRenList();
          break;
      }
    },
    goAudit (row) {
      this.auditShow = true;
      this.auditData = row;
    },
    goDetail (row) {
      this.detailShow = true;
      this.detailData = row;
    },
    goAssign (row) {
      this.assignShow = true;
      this.assignData = row;
    },
    goConfirmOrder (row) {
      this.confirmOrderShow = true;
      this.confirmOrderData = row;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
// /deep/.el-tabs__active-bar {
//   max-width: 64px !important;
//   max-width: 84px !important;
// }
</style>



// WEBPACK FOOTER //
// src/views/workOrder_Audit/workOrder_Audit.vue